import { createStyles } from '@mui/styles';

// Types
import { APTheme } from '../../../../core/TenantProvider/tenants'

export default (theme: APTheme) => createStyles({
  itemContainer: {
    alignItems: 'space-between',
    display: 'flex'
  },
  itemIcon: {
    width: 18,
    height: 18,
    marginRight: 10
  },
  itemLabel: {
    fontSize: 15,
    marginRight: 10
  },
  accountSelectLabelContainer: {
    marginRight: 10
  },
  accountNameContainer: {
    whiteSpace: 'normal'
  },
  selectedOptionTickIcon: {
    width: 20,
    height: 20,
    marginLeft: 'auto'
  },
  unSelectedOptionCircle: {
    width: 14,
    height: 14,
    borderRadius: '100%',
    border: '1px solid #CCCCCC',
    marginLeft: 'auto'
  }
});
